<template lang="html">
    <div class="d-flex border-top-medium border-bottom-medium align-items-center py-2">
        <label class="fs-large">Transport:</label>
        <div class="d-flex flexGrow1 align-items-center">
            <div class="bold fs-smaller d-flex flex-column flexGrow1 px-2">
                <span v-for="transfer in transport.transfers" v-if="transfer.schedule">
                    {{(transfer.transportDirection == '1')? 'Pickup' : 'Dropoff'}}:
                    {{transfer.schedule.timeShort}}
                    {{(transfer.transportDirection == '2')? reservation.event.location + ' -' : ''}}
                    {{transfer.stop.name}}
                    {{(transfer.transportDirection == '1')? '- '+ reservation.event.location : ''}}
                </span>
            </div>
            <div class="d-flex justify-content-end">
                <button :disabled="disabled" v-if="hasTransport" class="btn secondary small" @click="toggleEditTransport">EDIT</button>
                <button :disabled="disabled" v-else-if="!hasTransport && hasEventTransport || reservation.event.eventRoutes.length > 0" class="btn secondary small" @click="toggleEditTransport">ADD</button>
                <span v-else-if="reservation.event.eventRoutes.length === 0 && !hasEventTransport" class="fs-small px-2 bold dark cursor-default">No transport available</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        reservation: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        transport: function () {
            return this.reservation.transport;
        },
        hasTransport: function () {
            return this.reservation.bookingComponents.some((comp) => comp.component.componentType === 1);
        },
        hasEventTransport: function () {
            return this.reservation.event.eventComponents.some((comp) => comp.component.componentType === 1);
        }
    },
    methods:{
        toggleEditTransport: function () {
            this.eventHub.$emit('editReservation_toggleEditTransport');
        },
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ClientTransport.vue?778e5342